import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

/*interface Props {
  projectId: number;
}*/

interface ReportRow {
  WorkGroup: string;
  Work: string;
  Notation: string;
  Achieved: number | null;
}

//export default function MarkwiseProgressReport({ projectId }: Props) {
export default function MarkwiseProgressReport() {
  const [params] = useSearchParams();

  const projectId = Number(params.get("projectId"));
 /*  const [qDate, setQDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null); */
  const [qDate, setQDate] = useState<string>("");
const [endDate, setEndDate] = useState(
  new Date().toISOString().split("T")[0]
);
  const [data, setData] = useState<ReportRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [usedQDate, setUsedQDate] = useState("");
  const [usedEndDate, setUsedEndDate] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);

  const API_BASE =
    process.env.REACT_APP_API_BASE || "https://localhost:7243/api";

    const loadProjectStartDate = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(
      `${API_BASE}/ProjectInfo/start-date/${projectId}`,
      {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
      }
    );

    if (!response.ok) {
      throw new Error("Unable to load Project Start Date");
    }

    const result = await response.json();

    setQDate(result.startDate);
  } catch (err) {
    console.error(err);
  }
};

  // ===============================
  // LOAD REPORT DATA
  // ===============================
  const fetchReport = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE}/MarkwiseProgressRange/report`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {})
          },
          body: JSON.stringify({
            wbs: -1 * projectId,
            qDate,
            endDate,
            lvl: 0
          })
        }
      );

      if (!response.ok) {
        const message = await response.text();
        throw new Error(message);
      }

      const result = await response.json();

      setData(result.data || []);
      setUsedQDate(result.usedQDate);
      setUsedEndDate(result.usedEndDate);
    } catch (err: any) {
      alert(err.message || "Error loading report");
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // EXPORT PDF
  // ===============================
  const exportPdf = async () => {
    try {
      setPdfLoading(true);

      const token = localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE}/MarkwiseProgressRangeExport/pdf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {})
          },
          body: JSON.stringify({
            wbs: -1 * projectId,
            qDate,
            endDate,
            lvl: 0
          })
        }
      );

      if (!response.ok) {
        const message = await response.text();
        throw new Error(message);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "markwiseprogressrangeexportpdf.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      alert(err.message || "PDF export failed");
    } finally {
      setPdfLoading(false);
    }
  };

 /* useEffect(() => {
    fetchReport();
  }, []);*/
  useEffect(() => {
  if (projectId) {
  //  fetchReport();
     loadProjectStartDate();
  }
}, [projectId]);

  // ✅ KEEP ACTIVITY NUMBERS (no regex removal)
  const cleanActivity = (name: string) => name?.trim();

  const { groupedRooms, activities, pivot } = useMemo(() => {
    const activitiesSet = new Set<string>();
    const grouping: Record<string, Set<string>> = {};

    data.forEach((row) => {
      if (row.WorkGroup) {
        activitiesSet.add(cleanActivity(row.WorkGroup));
      }

      const section = row.Work?.trim() || "Other";

      if (!grouping[section]) grouping[section] = new Set();
      if (row.Notation) grouping[section].add(row.Notation.trim());
    });

    const activitiesArray = Array.from(activitiesSet).sort();

    const groupedRoomsObj: Record<string, string[]> = {};
    Object.keys(grouping).forEach((section) => {
      groupedRoomsObj[section] = Array.from(grouping[section]).sort();
    });

    const pivotObj: Record<string, Record<string, number | null>> = {};

    // Initialize pivot structure with null
    Object.values(groupedRoomsObj).forEach((rooms) => {
      rooms.forEach((room) => {
        pivotObj[room] = {};
        activitiesArray.forEach((act) => {
          pivotObj[room][act] = null;
        });
      });
    });

    // ✅ Assign backend value directly (NO SUMMING)
    data.forEach((row) => {
      const room = row.Notation?.trim();
      const activity = cleanActivity(row.WorkGroup);

      if (room && activity) {
        pivotObj[room][activity] =
          row.Achieved !== null && row.Achieved !== undefined
            ? row.Achieved
            : null;
      }
    });

    return {
      groupedRooms: groupedRoomsObj,
      activities: activitiesArray,
      pivot: pivotObj
    };
  }, [data]);

  return (
    <div className="bg-white p-4 rounded shadow">
      <h2 className="text-xl font-semibold mb-4 flex justify-between items-center">
        Markwise Progress Report
        <button
          onClick={exportPdf}
          disabled={pdfLoading}
          className="bg-green-600 text-white px-4 py-1 rounded"
        >
          {pdfLoading ? "Exporting..." : "Export PDF"}
        </button>
      </h2>

      <div className="flex gap-4 mb-4 flex-wrap">
        <div>
          <label className="mr-2">From Date</label>
          <input
            type="date"
            value={qDate ?? ""}
           // onChange={(e) => setQDate(e.target.value || null)}
           onChange={(e) => setQDate(e.target.value)}
            className="border p-1 rounded"
          />
        </div>

        <div>
          <label className="mr-2">To Date</label>
          <input
            type="date"
            value={endDate ?? ""}
           // onChange={(e) => setEndDate(e.target.value || null)}
           onChange={(e) => setEndDate(e.target.value)}
            className="border p-1 rounded"
          />
        </div>

        <button
          onClick={fetchReport}
          className="bg-blue-600 text-white px-4 py-1 rounded"
        >
          Apply
        </button>
      </div>

      <div className="text-sm text-gray-600 mb-3">
        Showing from{" "}
        <b>
          {usedQDate
            ? new Date(usedQDate).toLocaleDateString("en-GB")
            : ""}
        </b>{" "}
        to{" "}
        <b>
          {usedEndDate
            ? new Date(usedEndDate).toLocaleDateString("en-GB")
            : ""}
        </b>
      </div>

      {loading && <div>Loading...</div>}

      <div className="overflow-auto max-h-[650px] border relative">
        <table className="min-w-max border text-xs border-collapse">
          <thead className="sticky top-0 z-20 shadow-md">
            <tr>
              <th className="sticky left-0 z-30 bg-gray-400 border p-2 text-left min-w-[220px]">
                Room / Area
              </th>

              {activities.map((act) => (
                <th
                  key={act}
                  className="border bg-[#6b6b2e] text-white p-0"
                  style={{ height: "160px", width: "40px" }}
                >
                  <div
                    style={{
                      writingMode: "vertical-rl",
                      transform: "rotate(180deg)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      fontSize: "10px"
                    }}
                  >
                    {act}
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {Object.entries(groupedRooms).map(([section, rooms]) => (
              <React.Fragment key={section}>
                <tr>
                  <td
                    colSpan={activities.length + 1}
                    className="bg-gray-200 font-semibold border px-3 py-2"
                  >
                    {section}
                  </td>
                </tr>

                {rooms.map((room) => (
                  <tr key={room}>
                    <td className="sticky left-0 bg-gray-50 border p-2 font-medium min-w-[220px]">
                      {room}
                    </td>

                    {activities.map((act) => {
                      const value = pivot[room]?.[act];

                      let colorClass = "text-gray-400";

                      if (value !== null && value !== undefined) {
                        if (value === 0) colorClass = "text-red-500";
                        else if (value > 0 && value < 100)
                          colorClass = "text-blue-600";
                        else if (value >= 100)
                          colorClass = "text-green-600 font-semibold";
                      }

                      return (
                        <td
                          key={act}
                          className={`border px-1 py-1 text-center ${colorClass}`}
                          style={{ width: "40px" }}
                        >
                          {value !== null && value !== undefined
                           // ? `${value}%`
                           ? `${parseFloat(Number(value).toFixed(2))}%`
                            : "-"}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}